import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DataCube from '../data-cube';
import {
  dataCategories,
  humanizeNumber,
  colorMatcher,
} from '../../helpers/formatters';
import styles from './data-cube-row.module.scss';

class DataCubeRow extends Component {
  getCubeData(label, councilData) {
    if (councilData.isBlank && label !== 'relativeRiskAssessment') return '-';
    switch (label) {
      case 'revenue':
        return councilData.revenue.total;
      case 'expenses':
        return councilData.expenses.total;
      case 'assets':
        return councilData.assets.total;
      case 'liabilities':
        return councilData.liabilities.total;
      case 'relativeRiskAssessment':
        return null;
      default:
        return null;
    }
  }
  renderCubes(councilData, type) {
    const { onCubeClick } = this.props;
    const categories = type
      ? dataCategories.filter(
          category => category.id !== 'sustainabilityIndicators'
        )
      : dataCategories;
    return (
      <div
        style={{ marginBottom: type === 'top' ? '45px' : 0 }}
        className={styles.dataCubeRow}
      >
        {categories.map((category, i) => {
          return (
            <DataCube
              key={i}
              label={category.label}
              value={humanizeNumber(
                this.getCubeData(category.id, councilData),
                category.unit
              )}
              type={type}
              color={colorMatcher(category.color)}
              onClick={() => onCubeClick(category.id)}
            />
          );
        })}
      </div>
    );
  }

  renderDoubleRow() {
    const { comparedCouncil, activeCouncil, onCubeClick } = this.props;
    const sustainabilityIndicatorsData = dataCategories.find(
      category => category.id === 'sustainabilityIndicators'
    );
    return (
      <div>
        <div className={styles.dataCubeRowTitle}>{activeCouncil.name}</div>
        <div className={styles.cubesDoubleRowWrapper}>
          <div className={styles.cubesDoubleRowComparing}>
            {this.renderCubes(activeCouncil, 'top')}
            <div className={styles.dataCubeRowTitle}>
              {comparedCouncil.name}
            </div>
            {this.renderCubes(comparedCouncil, 'bottom')}
          </div>
          <DataCube
            label={sustainabilityIndicatorsData.label}
            text={sustainabilityIndicatorsData.text}
            color={colorMatcher(sustainabilityIndicatorsData.color)}
            onClick={() => onCubeClick(sustainabilityIndicatorsData.id)}
          />
        </div>
      </div>
    );
  }

  render() {
    const { comparedCouncil, activeCouncil } = this.props;
    return (
      <div className={styles.dataCubeRowWrapper}>
        {comparedCouncil
          ? this.renderDoubleRow()
          : this.renderCubes(activeCouncil)}
      </div>
    );
  }
}

DataCubeRow.propTypes = {
  activeCouncil: PropTypes.object.isRequired,
  comparedCouncil: PropTypes.object,
  onCubeClick: PropTypes.func.isRequired,
};

export default DataCubeRow;



// WEBPACK FOOTER //
// ./src/components/data-cube-row/data-cube-row.js